import { phone } from "phone";

function formatPhoneNumber(phoneNumberString) {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
}

export default (number: string) => {
  const { isValid, phoneNumber } = phone(number);

  if (!isValid) {
    return `${number} (invalid)`;
  }

  const cleanedPhone = formatPhoneNumber(phoneNumber);

  return cleanedPhone ? cleanedPhone : number;
};
